import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormValues } from 'sabis-dynamicform';
import { EditorData, FormValue } from 'sabis-dynamicform-core/cjs/Models/DynamicFormModel';
import { CommandResult } from '../../shared/api-common-models';

@Injectable({
  providedIn: 'root'
})
export class ReferenceCheckPublicService {

  constructor(@Inject('API_URL') private _apiUrl: string
    , private _http: HttpClient
  ) { }

  public getReferenceCheckReplyInitData(requestPublicId: string): Observable<ReferenceCheckReplyInitDTO> {
    let url: string = `${this._apiUrl}/public/feedback-requests/${requestPublicId}/reply/init-data`;

    return this._http.get<ReferenceCheckReplyInitDTO>(url);
  }

  public setReply(requestPublicId: string, command: SetReferenceCheckRequestReplyCommand): Observable<CommandResult> {
    let url: string = `${this._apiUrl}/public/feedback-requests/${requestPublicId}/reply`;

    return this._http.post<CommandResult>(url, command);
  }

  public cancelFeedbackRequest(feedbackRequestId: number): Observable<CommandResult> {
    let url: string = `${this._apiUrl}/public/feedback-requests/${feedbackRequestId}/cancel`;

    return this._http.post<CommandResult>(url, null);
  }
}

export interface ReferenceCheckReplyInitDTO {
  templateVersionId: number;
  templateVersionNumber: number;
  templateName: string;
  templateDescription: string;
  canEdit: boolean;
  editorInitData: EditorData;
  values: FormValues | null;
  isFeedbackRequestCanceled: boolean;
}

export interface SetReferenceCheckRequestReplyCommand {
  templateVersionId: number;
  formData: FormValue;
}
